import { WaitlistForm } from "./WaitlistForm";
import { Instagram, Facebook, Mail, Settings } from "lucide-react";
import { Link } from "react-router-dom";
import EditableText from "./EditableText";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0B0A4A] text-[#F4ECFF] px-6 sm:px-10 pt-24 sm:pt-32 pb-12 overflow-hidden">
      <div
        className="absolute -top-32 left-1/2 -translate-x-1/2 w-[100vw] sm:w-[700px] max-w-[700px] h-[500px] sm:h-[700px] rounded-full opacity-25 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, #B87CFF 0%, transparent 65%)" }}
      />

      <div className="relative max-w-5xl mx-auto text-center">
        <EditableText k="footer.eyebrow" fallback="One last thing" className="eyebrow text-[#EADDFF]" data-testid="footer-eyebrow" />

        <h2 className="editorial-display mt-6 text-4xl sm:text-5xl lg:text-6xl text-[#F4ECFF]" data-testid="footer-heading">
          <EditableText k="footer.heading" fallback="Sync with your body. Save up to $180 a year." multiline />
        </h2>

        <p className="mt-5 text-base sm:text-lg text-[#F4ECFF]/70 font-sans max-w-2xl mx-auto" data-testid="footer-subheading">
          <EditableText
            k="footer.subheading"
            fallback="Founding access closes when we launch on August 1, 2026. Drop your email and your rate is locked — $13/month for life, or just $10/month annual."
            multiline
          />
        </p>

        <div className="mt-10 max-w-xl mx-auto">
          <WaitlistForm variant="dark" source="footer" testIdPrefix="footer" cta="Lock in founding rate" />
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto mt-24 pt-10 border-t border-[#F4ECFF]/15">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-1" data-testid="footer-attribution">
            <div className="font-serif text-2xl text-[#F4ECFF]" data-testid="footer-logo">
              Feminine<span className="text-[#B87CFF]">Ways</span>
            </div>
            <a
              href="https://charlottebryan.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[11px] uppercase tracking-[0.22em] text-[#F4ECFF]/60 hover:text-[#B87CFF] transition-colors"
              data-testid="footer-charlotte-link"
            >
              <EditableText k="footer.attribution" fallback="A Charlotte Bryan app" />
            </a>
          </div>

          <div className="flex items-center gap-5">
            <a
              href="https://instagram.com/femininewaysapp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram @femininewaysapp"
              className="text-[#F4ECFF]/70 hover:text-[#B87CFF] transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram className="w-5 h-5" strokeWidth={1.5} />
            </a>
            <a
              href="https://facebook.com/femininewaysapp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook @femininewaysapp"
              className="text-[#F4ECFF]/70 hover:text-[#B87CFF] transition-colors"
              data-testid="footer-facebook"
            >
              <Facebook className="w-5 h-5" strokeWidth={1.5} />
            </a>
            <a
              href="mailto:FeminineWaysApp@gmail.com"
              aria-label="Email FeminineWaysApp@gmail.com"
              className="text-[#F4ECFF]/70 hover:text-[#B87CFF] transition-colors"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5" strokeWidth={1.5} />
            </a>
          </div>

          <p className="text-xs text-[#F4ECFF]/50 tracking-wide flex items-center gap-3" data-testid="footer-copyright">
            <EditableText k="footer.copyright" fallback={`© ${new Date().getFullYear()} Feminine Ways. Built with care.`} as="span" />
            <Link
              to="/admin/login"
              aria-label="Admin sign in"
              title="Admin"
              className="text-[#F4ECFF]/30 hover:text-[#B87CFF] transition-colors"
              data-testid="footer-admin-link"
            >
              <Settings className="w-3.5 h-3.5" strokeWidth={1.5} />
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
